export default (data) => {
    return {
        ...data,
        rc_owner_name: data.customerName,
        ds_details: data.variant ? [{variant: data.variant}] : null
    };
};
